import { render, staticRenderFns } from "./BaseCounter.vue?vue&type=template&id=58d6e15c&"
import script from "./BaseCounter.vue?vue&type=script&lang=js&"
export * from "./BaseCounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports